import { resource } from './client.ts';
const resourceObj = resource('notifications');
const {
  get: getNotifications,
  show: getNotification,
  send: sendNotification,
} = resourceObj;

const getUnreadNotifications = () => {
  const { get } = resource('notifications/user/unread');
  return get();
};

const markNotificationAsRead = (notificationUuid: string) => {
  const { replace } = resource(`notifications/user/${notificationUuid}/read`);
  return replace();
};

const markAllNotificationsAsRead = () => {
  const { replace } = resource('notifications/user/read-all');
  return replace();
};

export {
  getNotification, getNotifications, getUnreadNotifications, markAllNotificationsAsRead, markNotificationAsRead, sendNotification
};

